// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"7609d75b","209":"d80f623c","717":"fd776f4e","829":"d42251fc"}[chunkId] + ".chunk.js";
};